import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import LaddaButton from "../../buttons/laddaButton";

const VerificationModal = ({
  open,
  handleClose,
  alertText,
  onConfirm,
  onCancel,
  iconSeverity,
  yesNo = false,
  loading: loadingFromParent = false
}) => {
  const [loadingLocal, setLoadingLocal] = useState(false);
  const loading = loadingFromParent || loadingLocal;

  const handleConfirmClick = async () => {
    try {
      setLoadingLocal(true);
      await onConfirm();
    } finally {
      setLoadingLocal(false);
    }
  };

  const getIcon = (iconSeverity) => {
    let iconurl = "";
    switch (iconSeverity) {
      case "danger":
        iconurl = "/icons/verification_dang.png";
        break;
      case "warning":
        iconurl = "/icons/verification_warn.png";
        break;
      case "info":
        iconurl = "/icons/verification_info.png";
        break;
      default:
        iconurl = "/icons/verification_info.png";
        break;
    }
    return iconurl;
  };

  return (
    <Dialog
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      aria-labelledby="verification-modal-title"
    >
      <DialogContent>
        <p className="button_text mb-10">Confirmación</p>
        <div className="IHContainer align-center">
          <img
            className="icon-verification mr-10"
            src={getIcon(iconSeverity)}
            alt="icon"
          />

          <p className="verification-modal-text">
            {alertText || "¿Estás seguro de realizar esta acción?"}
          </p>
        </div>
      </DialogContent>
      <DialogActions>
        <LaddaButton
          color="6A6AD8"
          backgroundColor={"white"}
          onClick={onCancel || handleClose}
          disabled={loading}
        >
          <div className="HContainer align-center">
            <p className="button_text">{yesNo ? "No" : "Cancelar"}</p>
          </div>
        </LaddaButton>
        <LaddaButton
          variant="contained"
          onClick={handleConfirmClick}
          loading={loading}
          disabled={loading}
        >
          <div className="HContainer align-center">
            <p className="button_text">{loading ? "Procesando..." : yesNo ? "Si" : "Aceptar"}</p>
          </div>
        </LaddaButton>
      </DialogActions>
    </Dialog>
  );
};

export default VerificationModal;
